<template>
  <div class="card w-100 h-100 d-flex flex-column">
    <div class="card-header d-flex justify-content-between align-items-center">
        {{ $t("labels.preview") }}
      <div class="preview-image-layout-count">
        {{ (currentPageNum + 1) + " / " + totalPageNum }}
      </div>
    </div>
    <div class="window-body d-flex flex-column flex-fill">
      <div class="preview-window">
        <div class="card overflow-auto h-100">
          <SettingPreviewImage
            :image="image"
            class="card-body"
          />
        </div>
      </div>
      <ul class="prev-area">
        <li
          v-show="currentPageNum > 0"
          class="prev"
          @click="prevPage"
        />
      </ul>
      <ul class="next-area">
        <li
          v-show="currentPageNum < (totalPageNum) -1"
          class="next"
          @click="nextPage"
        />
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * 宿題管理 - PDFプレビュー
 */
import SettingPreviewImage from "@/components/atoms/SettingPreviewImage.vue"

export default {
  name: "PreviewPdfContainer",
  components: {
    SettingPreviewImage,
  },
  props: {
    previewBase64: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },
    imgList: {
      type: Array,
      require: true,
      default: () => {return []}
    }
  },

  data: ()=>({
    currentPageNum: 0,  // 現在のページ
    totalPageNum: 1,    // 総ページ数
    image: null,
    imageList:[],
  }),

  mounted : function (){
    this.imageList = this.imgList
    this.totalPageNum = this.imgList.length
    this.image = this.imgList[0].file_image
  },

  methods: {

    // 前ページへ
    prevPage: function() {
      if (this.currentPageNum <= 0) return
      this.currentPageNum--
      this.image = this.imgList[this.currentPageNum].file_image
    },

    // 後ページへ
    nextPage: function() {
      if (this.currentPageNum > this.totalPageNum) return
      this.currentPageNum++
      this.image = this.imgList[this.currentPageNum].file_image
    },
  },
}
</script>

<style lang="scss" scoped>
.card-header {
  border-bottom: none;
  background: var(--bs-table-header);
  color: var(--bs-layout-theme);
  font-weight: bold;
}

.preview-image-layout-count {
  color: var(--bs-body-color);
  font-weight: normal;
}

.window-body {
  padding: 1rem 54px;
  position: relative;
  min-height: 0;
}

.prev-area {
  position: absolute;
  top: 50%;
  left: 12px;
  margin: 0;
  padding: 0;
}

.prev {
  display: block;
  padding: 20px 15px;
  cursor: pointer;
  height: auto;
  transform: translateY(-50%);

  &::before {
    content: "";
    display: inline-block;
    position: absolute;
    background: #0070c0;
    width: 20px;
    height: 4px;
    transform: rotate(-45deg);
    top: 12px;
    left: 5px;
  }

  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    background: #0070c0;
    width: 20px;
    height: 4px;
    transform: rotate(45deg);
    top: 24px;
    left: 5px;
  }
}

.next-area {
  position: absolute;
  top: 50%;
  right: 12px;
  margin: 0;
  padding: 0;
}

.next {
  display: block;
  padding: 20px 15px;
  cursor: pointer;
  height: auto;
  transform: translateY(-50%);

  &::before {
    content: "";
    display: inline-block;
    position: absolute;
    background: #0070c0;
    width: 20px;
    height: 4px;
    transform: rotate(-45deg);
    top: 24px;
    right: 5px;
  }

  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    background: #0070c0;
    width: 20px;
    height: 4px;
    transform: rotate(45deg);
    top: 12px;
    right: 5px;
  }
}

.preview-window {
  min-height: 0;
  flex: 1;
}
</style>
